// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vue-listing__head[data-v-13884ada]{display:flex;align-items:center;margin:30px 0 10px}.vue-listing__icon[data-v-13884ada]{color:#4fc08d;font-size:30px;margin-right:15px}.vue-listing__title[data-v-13884ada]{font-size:20px}", ""]);
// Exports
module.exports = exports;
